export type ContactOption = {
  label: string;
  value: string;
  email: string;
  name: string;
};

type CustomerDocRow = {
  email?: string | null;
  name?: string | null;
};

type ContactRow = {
  email: string;
  name: string;
};

export function buildContactOptions(params: {
  customer: CustomerDocRow | undefined;
  contacts: ContactRow[] | undefined;
  defaultReporterEmail: string;
  defaultReporterName: string;
}): ContactOption[] {
  const options: ContactOption[] = [];
  const customerEmail = params.customer?.email?.trim().toLowerCase() ?? "";
  const customerName = params.customer?.name?.trim() ?? "";
  if (customerEmail && customerName) {
    options.push({
      label: `${customerName} (${customerEmail})`,
      value: `${customerEmail}|${customerName}`,
      email: customerEmail,
      name: customerName,
    });
  }
  for (const contact of params.contacts ?? []) {
    const email = contact.email.trim().toLowerCase();
    const name = contact.name.trim();
    if (!email || !name) continue;
    options.push({
      label: `${name} (${email})`,
      value: `${email}|${name}`,
      email,
      name,
    });
  }
  const fallbackEmail = params.defaultReporterEmail.trim().toLowerCase();
  const fallbackName = params.defaultReporterName.trim() || fallbackEmail.split("@")[0];
  if (fallbackEmail) {
    options.push({
      label: `${fallbackName} (${fallbackEmail})`,
      value: `${fallbackEmail}|${fallbackName}`,
      email: fallbackEmail,
      name: fallbackName,
    });
  }
  const deduplicated: ContactOption[] = [];
  for (const option of options) {
    if (!deduplicated.some((item) => item.value === option.value)) deduplicated.push(option);
  }
  return deduplicated;
}
